import { render, staticRenderFns } from "./SectionHeader.vue?vue&type=template&id=10708c96&shadow"
import script from "./SectionHeader.vue?vue&type=script&lang=js&shadow"
export * from "./SectionHeader.vue?vue&type=script&lang=js&shadow"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports